import { render, staticRenderFns } from "./questionEditor.vue?vue&type=template&id=dfea7e7e&scoped=true&"
import script from "./questionEditor.vue?vue&type=script&lang=js&"
export * from "./questionEditor.vue?vue&type=script&lang=js&"
import style0 from "./questionEditor.vue?vue&type=style&index=0&id=dfea7e7e&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "dfea7e7e",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VDivider } from 'vuetify/lib/components/VDivider';
import { VExpandTransition } from 'vuetify/lib/components/transitions';
import { VHover } from 'vuetify/lib/components/VHover';
import { VIcon } from 'vuetify/lib/components/VIcon';
import { VSheet } from 'vuetify/lib/components/VSheet';
installComponents(component, {VBtn,VDivider,VExpandTransition,VHover,VIcon,VSheet})
